var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "row page-title-header"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('BreadCrumb', {
    attrs: {
      "parentRouteName": "BookingSelectList"
    }
  })], 1)]), _c('b-card', [_c('div', {
    staticClass: "d-flex mb-4 mb-xl-2 justify-content-between align-items-center"
  }, [_c('h4', {
    staticClass: "mb-0 font-weight-bold"
  }, [_vm._v("預約管理")]), _c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('b-form-select', {
    staticClass: "mr-3",
    attrs: {
      "options": _vm.validityStatusOptions
    },
    on: {
      "change": _vm.handlePageReset
    },
    model: {
      value: _vm.query.is_valid,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "is_valid", $$v);
      },
      expression: "query.is_valid"
    }
  }), _c('b-form-select', {
    staticClass: "mr-3",
    attrs: {
      "options": _vm.publishStatusOptions
    },
    on: {
      "change": _vm.handlePageReset
    },
    model: {
      value: _vm.query.status,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "status", $$v);
      },
      expression: "query.status"
    }
  }), _c('b-input-group', {
    staticStyle: {
      "min-width": "300px"
    }
  }, [_c('b-form-input', {
    attrs: {
      "placeholder": "搜尋"
    },
    on: {
      "keydown": function keydown($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleSearchKeyPress.apply(null, arguments);
      },
      "compositionstart": function compositionstart($event) {
        _vm.isComposing = true;
      },
      "compositionend": function compositionend($event) {
        _vm.isComposing = false;
      }
    },
    model: {
      value: _vm.searchKeyword,
      callback: function callback($$v) {
        _vm.searchKeyword = $$v;
      },
      expression: "searchKeyword"
    }
  }), _c('b-input-group-append', [_c('b-button', {
    on: {
      "click": _vm.handleSearch
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])], 1)], 1)], 1)]), _c('b-card-text', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('b-overlay', {
    attrs: {
      "show": _vm.showLoading,
      "rounded": "sm"
    }
  }, [_c('b-table', {
    attrs: {
      "striped": "",
      "hover": "",
      "responsive": "",
      "items": _vm.bookingPresets,
      "fields": _vm.fields
    },
    scopedSlots: _vm._u([{
      key: "cell(is_valid)",
      fn: function fn(data) {
        return [_c('b-badge', {
          attrs: {
            "variant": data.item.is_valid ? 'success' : 'danger'
          }
        }, [_vm._v(" " + _vm._s(data.item.is_valid ? '生效中' : '已失效') + " ")])];
      }
    }, {
      key: "cell(status)",
      fn: function fn(data) {
        return [data.item.status == 'published' ? _c('b-badge', {
          attrs: {
            "variant": "success"
          }
        }, [_vm._v(" 發布 ")]) : _vm._e(), data.item.status == 'closed' ? _c('b-badge', {
          attrs: {
            "variant": "danger"
          }
        }, [_vm._v(" 關閉 ")]) : _vm._e(), data.item.status == 'draft' ? _c('b-badge', {
          attrs: {
            "variant": "warning"
          }
        }, [_vm._v(" 草稿 ")]) : _vm._e()];
      }
    }, {
      key: "cell(name)",
      fn: function fn(data) {
        return [_c('RouterLink', {
          attrs: {
            "to": {
              name: 'BookingList',
              params: {
                id: data.item.id
              }
            }
          }
        }, [_vm._v(" " + _vm._s(data.item.name) + " ")])];
      }
    }, {
      key: "cell(actions)",
      fn: function fn(data) {
        return [_vm.checkPermission([_vm.consts.BOOKING_LIST]) ? _c('b-button', {
          staticClass: "mr-1",
          attrs: {
            "variant": "inverse-dark"
          },
          on: {
            "click": function click($event) {
              return _vm.showFormUrl(data.item);
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-link"
        })]) : _vm._e(), _vm.checkPermission([_vm.consts.BOOKING_LIST]) ? _c('b-button', {
          staticClass: "mr-1",
          attrs: {
            "variant": "inverse-warning",
            "to": {
              name: 'BookingList',
              params: {
                id: data.item.id
              }
            }
          }
        }, [_c('span', {
          staticClass: "mdi mdi-format-list-bulleted"
        }), _vm._v(" 預約紀錄 ")]) : _vm._e(), _vm.checkPermission([_vm.consts.BOOKING_BRANCH_SETTING_MODIFY]) ? _c('b-button', {
          staticClass: "mr-1",
          attrs: {
            "variant": "inverse-dark",
            "to": {
              name: 'BookingBranchPresetBasicEdit',
              params: {
                id: data.item.id,
                branch: _vm.branchId
              }
            }
          }
        }, [_c('i', {
          staticClass: "mdi mdi-settings"
        }), _vm._v(" 基本設定 ")]) : _vm._e(), _vm.checkPermission([_vm.consts.BOOKING_BRANCH_NOTIFICATION_SETTING]) && data.item.type === 'wizard' ? _c('b-button', {
          staticClass: "mr-1",
          attrs: {
            "variant": "inverse-primary",
            "to": {
              name: 'BookingBranchPresetNotification',
              params: {
                id: data.item.id,
                branch: _vm.branchId
              }
            }
          }
        }, [_c('i', {
          staticClass: "mdi mdi-bell-ring-outline"
        }), _vm._v(" 分店預約通知 ")]) : _vm._e(), _vm.checkPermission([_vm.consts.BOOKING_SETTING]) && data.item.config && data.item.config.booking_mapping && data.item.config.booking_mapping.bookings && data.item.config.booking_mapping.bookings.start_at_by_branch !== null ? _c('b-button', {
          staticClass: "mr-1",
          attrs: {
            "variant": "inverse-info",
            "to": {
              name: 'BookingBranchPresetEdit',
              params: {
                id: data.item.id,
                branch: _vm.branchId
              }
            }
          }
        }, [_c('i', {
          staticClass: "mdi mdi-timetable"
        }), _vm._v(" 時段設定 ")]) : _vm._e(), _vm.checkPermission([_vm.consts.BOOKING_BRANCH_SHIFT_LIST_VIEW]) ? _c('b-button', {
          staticClass: "mr-1 btn-inverse-success",
          attrs: {
            "to": {
              name: 'BookingBranchShiftList',
              params: {
                id: data.item.id
              }
            }
          }
        }, [_c('i', {
          staticClass: "mdi mdi-sleep"
        }), _vm._v(" 店休設定 ")]) : _vm._e()];
      }
    }])
  })], 1)], 1)]), _c('CustomPagination', {
    attrs: {
      "currentPage": _vm.query.page,
      "totalRows": _vm.totalRows,
      "perPage": _vm.query.per_page
    },
    on: {
      "page-change": _vm.handlePageChange,
      "per-page-change": _vm.handlePerPageChange
    }
  })], 1)], 1), _c('FormUrlModal', {
    ref: "formUrlModal"
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }